// extracted by mini-css-extract-plugin
export var icon = "_bm-3";
export var subtitle = "_bm-2";
export var title = "_bm-1";
export var value = "_bm-0";